const filter = {
  items: [{ columnField: 'openQty', operatorValue: '>', value: 0 }],
}

export default filter
